import _ from 'lodash';
import RefData from 'ref-data';

/**
 * entry export servers
 */
const exportServers = {
  HERCULES_1: 'hercules1',
  HERCULES_2: 'hercules2',
};

/**
 * possible export types
 */
const exportTypes = {
  PARTICIPANTS: RefData.Enum.TYPE.EXPORT.CAMPAIGNLEADS,
  COUPONS:      RefData.Enum.TYPE.EXPORT.CODECAMPAIGNREDEMPTIONS,
  WINNERS:      RefData.Enum.TYPE.EXPORT.WINNERS, //try to track down if this one can be replaced with RefData.Enum.TYPE.EXPORT_PARTITION.WINNERS
};
exportTypes.ALL = _.values(exportTypes);

/**
 * add/last export urls for all servers and export types
 */
const exportUrls = {
  [exportServers.HERCULES_1]: {
    [exportTypes.PARTICIPANTS]: {
      addExportUrl:  '/api/exporttask/addExport.json',
      lastExportUrl: '/api/exporttask/lastExport.json',
    },
    [exportTypes.COUPONS]: {
      addExportUrl:  '/api/exporttask/addRedemptionExport.json',
      lastExportUrl: '/api/exporttask/lastExport.json',
    },
    [exportTypes.WINNERS]: {
      addExportUrl:   '/api/exporttask/addWinnerExport.json',
      lastExportUrl:  '/api/exporttask/lastExport.json',
      getPasswordUrl: '/api/exporttask/getExportPassword.json',
    },
  },

  /**
   * IMPORTANT !!!
   * This urls are NOT going to coreapp.
   * They are used with ajaxService.hercules, and that's appending them to `${App.globalContext.herculesURL}`,
   * see common\Services\AjaxService.js, `const herculesInstance`
   */
  [exportServers.HERCULES_2]: {
    [exportTypes.PARTICIPANTS]: {
      addExportUrl:  'entry/export',
      lastExportUrl: 'entry/status',
    },
    [exportTypes.COUPONS]: {
      addExportUrl:  'redemption/export',
      lastExportUrl: 'redemption/status',
    },
    [exportTypes.WINNERS]: {
      addExportUrl:   'winner/export',
      lastExportUrl:  'winner/status',
      getPasswordUrl: 'winner/password',
    },
  },
};

export default { exportTypes, exportUrls, exportServers };
